module.exports = __webpack_public_path__ + "img/16.17039ef4.png";